module.exports = __webpack_public_path__ + "static/img/national-Day-activities-pc.ccca6178.png";